/**
 * Extensiones de la barra de acciones del listado dynamic-model (selección múltiple).
 * Los módulos registran componentes Vue que reciben selectedItemIds, modelName, items, isTrashView.
 */

/** @type {Array<{ component: Function|object, requiresModule: string|null }>} */
const extensions = [];

export function registerDynamicListToolbarExtension({
  component,
  requiresModule = null,
}) {
  if (!component) return;
  extensions.push({ component, requiresModule });
}

function isModuleActive(moduleName, activeModules) {
  if (!moduleName) return true;
  const list = Array.isArray(activeModules) ? activeModules : [];
  return list.some((m) => {
    const name = typeof m === "string" ? m : m?.name;
    return name === moduleName;
  });
}

function getActiveModulesFromStorage() {
  try {
    const raw = localStorage.getItem("activeModules");
    return raw ? JSON.parse(raw) : [];
  } catch (_) {
    return [];
  }
}

export async function fetchActiveModulesForToolbar() {
  try {
    const { wencesApi } = await import("@/api/wencesApi");
    const response = await wencesApi.get("/api/modules/active");
    let modules = [];
    if (response.data && Array.isArray(response.data)) {
      modules = response.data;
    } else if (response.data?.data && Array.isArray(response.data.data)) {
      modules = response.data.data;
    }
    if (modules.length > 0) {
      localStorage.setItem("activeModules", JSON.stringify(modules));
    }
    return modules;
  } catch (_) {
    return getActiveModulesFromStorage();
  }
}

export function getDynamicListToolbarExtensions(activeModules) {
  const modules =
    activeModules !== undefined ? activeModules : getActiveModulesFromStorage();
  return extensions.filter((ext) => isModuleActive(ext.requiresModule, modules));
}

export function getRegisteredDynamicListToolbarExtensions() {
  return extensions.slice();
}
